import { FAQ, Panel, PanelState, theme, useMediaMin, VerticalSpacer } from '@foradevelopment/fora-ui';
import { EmploymentViewModelNew, UpdateEmploymentInput } from '@fora-monorepo/employer-my-pages-common/types';

import { PersonDetails } from '../../../components';
import { useAppSelector } from '../../../redux/hooks';
import { EditEmploymentPeriodForm } from '../../components/EditEmploymentPeriodForm';

export const EditEmploymentPeriodPanel = ({
  employment,
  panelState,
  goToNextPanel,
  employmentPeriodIndex,
}: {
  employment: EmploymentViewModelNew;
  panelState: PanelState;
  goToNextPanel: (employment: EmploymentViewModelNew) => void;
  employmentPeriodIndex: number;
}) => {
  const faqs = useAppSelector(state => state.content.content.faqListEditEmploymentPeriod);
  const isDesktop = useMediaMin(theme.breakpoint.lg);
  const { employeeId, lastName, firstName, address, partnerNumberIndividual } = employment.employee;

  const editEmployeeInputData: UpdateEmploymentInput = {
    employeeId: employeeId,
    lastName: lastName,
    firstName: firstName,
    employmentPeriod: {
      index: employmentPeriodIndex,
      employmentStartDate: employment.employmentPeriods[employmentPeriodIndex].employmentStartDate,
      employmentEndDate: employment.employmentPeriods[employmentPeriodIndex].employmentEndDate,
      markups: employment.employmentPeriods[employmentPeriodIndex].markups,
      fokParameterChoices: employment.employmentPeriods[employmentPeriodIndex].fokParameterChoices.map(x => ({
        parameterValue: x.parameterValue,
        startDate: x.startDate,
        endDate: x.endDate ?? undefined,
      })),

      // Lägg till fler fält som behövs för EmploymentPeriodInput
    },
    partnerNumberIndividual: partnerNumberIndividual,
    addressInfo: address,
  };

  return (
    <Panel {...panelState} name="edit-employment-panel">
      <Panel.Header marginTop="0px">Ändra anställningsperiod</Panel.Header>
      <Panel.Body>
        <Panel.MainSection>
          <PersonDetails {...employment.employee} />
          <VerticalSpacer marginBottom={60} />
          <EditEmploymentPeriodForm
            employment={employment}
            goToConfirmationPanel={goToNextPanel}
            editEmployeeInputData={editEmployeeInputData}
            employmentPeriodIndex={employmentPeriodIndex}
            // TODO: Remove when the start date of the first employment period becomes editable.
            isFirstEmploymentPeriod={employmentPeriodIndex === 0}
          />
        </Panel.MainSection>
        <Panel.AsideSection>
          {faqs.length > 0 && isDesktop && (
            <FAQ testId="test-edit-employment-faq" layout="side" questionAnswers={faqs} />
          )}
        </Panel.AsideSection>
        {faqs.length > 0 && !isDesktop && (
          <FAQ testId="test-edit-employment-faq" layout="modal" questionAnswers={faqs} />
        )}
      </Panel.Body>
    </Panel>
  );
};
